export default {
  pageTitle: 'Permission Management',
  pageDesc: 'Manage organization structure and role permission configuration',
  orgTree: 'Organization Structure',
  searchOrg: 'Search organization',
  allExpand: 'Expand All',
  allCollapse: 'Collapse All',
  selectNodeEmpty: 'Please select a node from the organization structure on the left',
  selectNodeHint: 'Select different types of nodes for corresponding management operations',
  editInfo: 'Edit Info',
  configPermission: 'Configure Permission',
  createCompany: 'Create Branch',
  createDepartment: 'Create Department',
  createRole: 'Create Role',
  chineseName: 'Chinese Name',
  englishName: 'English Name',
  code: 'Code',
  departmentCode: 'Department Code',
  baseCurrency: 'Base Currency',
  country: 'Country',
  createTime: 'Created At',
  updateTime: 'Updated At',
  save: 'Save',
  cancel: 'Cancel',
  create: 'Create',
  nodeType: {
    group: 'Group',
    office: 'Branch',
    company: 'Company',
    department: 'Department',
    role: 'Role'
  },
  permissionConfig: 'Permission Config',
  permissionConfigTitle: '{name} - Permission Config',
  back: 'Back',
  saveConfig: 'Save Config',
  authorized: 'Authorized Permissions',
  unauthorized: 'Unauthorized Permissions',
  addPermission: 'Add Permission',
  removePermission: 'Remove Permission',
  operationTip: 'Select permissions and use the buttons below to move. Selecting a sub-permission will automatically include its parent.',
  permissionName: 'Permission Name',
  permissionClass: 'Permission Class',
  permissionType: 'Permission Type',
  permissionPoint: 'Permission Point',
  modal: {
    editTitle: 'Edit Info',
    createTitle: 'Create {type}',
    ok: 'Save',
    cancel: 'Cancel',
    create: 'Create'
  },
  form: {
    chineseName: 'Chinese Name',
    englishName: 'English Name',
    code: 'Code',
    departmentCode: 'Department Code',
    baseCurrency: 'Base Currency',
    country: 'Country',
    chineseNamePlaceholder: 'Please enter Chinese name',
    englishNamePlaceholder: 'Please enter English name',
    codePlaceholder: 'Please enter code',
    departmentCodePlaceholder: 'Please enter department code',
    baseCurrencyPlaceholder: 'Please enter base currency',
    countryPlaceholder: 'Please select country',
    chineseNameRequired: 'Please enter Chinese name',
    englishNameRequired: 'Please enter English name',
    codeRequired: 'Please enter code',
    departmentCodeRequired: 'Please enter department code',
    countryRequired: 'Please select country'
  },
  messages: {
    loadTreeSuccess: 'Organization structure loaded successfully',
    loadTreeFail: 'Failed to load organization structure',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    createSuccess: 'Created successfully',
    createFail: 'Create failed',
    updateSuccess: 'Updated successfully',
    updateFail: 'Update failed',
    deleteSuccess: 'Deleted successfully',
    deleteFail: 'Delete failed',
    configSuccess: 'Permission configured successfully',
    configFail: 'Permission configuration failed',
    confirmDelete: 'Are you sure to delete this {type}?',
    noNodeSelected: 'Please select a node first',
    loading: 'Loading...',
    operationFailed: 'Operation failed',
    networkError: 'Network error, please try again later',
    dataAuthSaveSuccess: 'Data permission saved successfully',
    dataAuthSaveFail: 'Failed to save data permission'
  },
  selectNodeEmptyV2: 'Please select an organization node on the left',
  selectNodeHintV2: 'Selecting different types of nodes enables corresponding management actions',
  dataAuth: {
    modalTitle: '{name} - Data Permission Config',
    tipText: 'Configure the data access scope for this feature. Multiple selections result in a union of all scopes.',
    typeLabel: 'Data Scope Type (multi-select)',
    all: 'All Data',
    allDesc: 'Can view all data in the system without restrictions',
    allTitle: 'All Data Permission',
    branch: 'Branch Data',
    department: 'Department Data',
    personal: 'Personal Data',
    selectBranch: 'Select Branch',
    selectDepartment: 'Select Department',
    selectPersonal: 'Select Personnel',
    branchPlaceholder: 'Please select branch',
    departmentPlaceholder: 'Please select department',
    personalPlaceholder: 'Please select personnel',
    configBtn: 'Data Permission',
    configured: 'Configured',
    notConfigured: 'Not Configured',
    editConfig: 'Edit',
    setConfig: 'Configure',
    revokeAuth: 'Revoke Authorization',
    revokeConfirmTitle: 'Confirm Revoke Authorization',
    revokeConfirmContent: 'Are you sure to revoke the data permission config for "{name}"? After revocation, this feature will revert to the default data access scope and all saved scope configs will be removed.',
    revokeConfirmOk: 'Confirm Revoke',
    revokeSuccess: 'Data permission authorization revoked',
    branchRequired: 'Please select at least one branch',
    departmentRequired: 'Please select at least one department',
    personalRequired: 'Please select at least one person',
    typeRequired: 'Please select at least one data scope type'
  }
}
